import { render, staticRenderFns } from "./InvestmentAnalyticsGraph.vue?vue&type=template&id=2dc9a938&"
import script from "./InvestmentAnalyticsGraph.vue?vue&type=script&lang=js&"
export * from "./InvestmentAnalyticsGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports